export default "__VITE_ASSET__BHtqMExz__"